export default {
  svgPath: `
    <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="2"/>
    <path d="M10 4L10 12" stroke="currentColor" stroke-width="2"/>
    <path d="M10 14V16" stroke="currentColor" stroke-width="2"/>
  `,
  title: 'Warning Circle',
  viewBox: '0 0 20 20',
};
